import { ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useSubscription } from "@/hooks/useSubscription";
import { openBillingPortal } from "@/lib/billing";

export const AccountDangerZoneCard = () => {
  const { subscription, isActive } = useSubscription();

  return (
    <Card className="shadow-soft border-destructive/30">
      <CardHeader><CardTitle className="text-destructive">Account danger zone</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        {isActive && !subscription?.cancel_at_period_end && (
          <div className="space-y-1.5">
            <Button
              variant="outline"
              onClick={async () => {
                if (!confirm("Open the billing portal to cancel your subscription? You'll keep access until the end of your current billing period.")) return;
                await openBillingPortal();
              }}
            >
              <ExternalLink className="h-4 w-4" />
              Cancel subscription
            </Button>
            <p className="text-xs text-muted-foreground">
              Cancels via Stripe. Access continues until{" "}
              {subscription?.current_period_end
                ? new Date(subscription.current_period_end).toLocaleDateString()
                : "the end of your billing period"}.
            </p>
          </div>
        )}
        <div className="space-y-1.5">
          <Button asChild variant="outline">
            <a href="mailto:accounts@excerptus.io?subject=Account%20closure%20request">
              Email to close account
            </a>
          </Button>
          <p className="text-xs text-muted-foreground">
            Account closure is handled by email so we can confirm the request, preserve required billing records,
            and remove the rest of your account data safely.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
